import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RETRY_INTERVAL_MS = 250;
const MAX_RETRIES = 40;

let lastTrackedUrl = null;

const getFbq = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (typeof window.fbq === 'function') {
    return window.fbq;
  }

  if (typeof window._fbq === 'function') {
    return window._fbq;
  }

  return null;
};

const useMetaPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const currentUrl = `${location.pathname}${location.search}${location.hash}`;

    if (lastTrackedUrl === currentUrl) {
      return;
    }

    let retries = 0;
    let timeoutId = null;
    let cancelled = false;

    const trackPageView = () => {
      if (cancelled) {
        return;
      }

      const fbq = getFbq();

      if (typeof fbq === 'function') {
        fbq('track', 'PageView');
        lastTrackedUrl = currentUrl;
        return;
      }

      if (retries >= MAX_RETRIES) {
        return;
      }

      retries += 1;
      timeoutId = window.setTimeout(trackPageView, RETRY_INTERVAL_MS);
    };

    trackPageView();

    return () => {
      cancelled = true;
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [location.pathname, location.search, location.hash]);
};

export default useMetaPageView;